export const parseIntFromString = (value) => {
  if (value === '') {
    return 0;
  }

  const sanitizedValue = value.replace(/[^0-9]/g, '');

  return parseInt(sanitizedValue, 10);
};
